import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { Observable } from 'rxjs';

import { QueryParams } from '../../models/http.models';
import { ApiKeyUser, User } from '../user.models';
import { Credentials } from '../../common/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class UsersResource {
  private apiRoot: string = `${process.env.API_URL}/user`;

  constructor(private http: HttpClient) {}

  get(params?: QueryParams): Observable<User> {
    return this.http.get<User>(`${this.apiRoot}`, { params });
  }

  save(body: Partial<User>, params?: QueryParams): Observable<User> {
    return this.http.post<User>(`${this.apiRoot}s`, body, { params });
  }

  update(body: Partial<User>, params?: QueryParams): Observable<User> {
    return this.http.put<User>(`${this.apiRoot}`, body, { params });
  }

  show_api_key(body: Partial<User>, params?: QueryParams): Observable<ApiKeyUser> {
    return this.http.post<User>(`${this.apiRoot}/show_api_key`, body, { params });
  }

  regenerate_tokens(body?: User, params?: QueryParams): Observable<ApiKeyUser> {
    return this.http.post<User>(`${this.apiRoot}/regenerate-tokens`, body, { params });
  }

  reset_password(body: { reset_password_token: string; password: string }, params?: QueryParams): Observable<User> {
    return this.http.put<User>(`${this.apiRoot}/password`, body, { params });
  }

  invitation(body: { password: string; invitation_token: string }, params?: QueryParams): Observable<User> {
    return this.http.put<User>(`${this.apiRoot}/invitation`, body, { params });
  }

  confirm(body: { password: string; confirmation_token: string }, params?: QueryParams): Observable<User> {
    return this.http.put<User>(`${this.apiRoot}/confirmation`, body, { params });
  }

  confirmEmail(body: { password: string; token: string }, params?: QueryParams): Observable<User> {
    return this.http.post<User>(`${this.apiRoot}/new_email_confirmation/${body.token}`, body, { params });
  }

  resetUserPassword(body: Credentials, params?: QueryParams): Observable<User> {
    return this.http.post<User>(`${process.env.API_URL}/user_password`, body, { params });
  }
}

((window as any).xplenty as angular.IModule).service('User', downgradeInjectable(UsersResource));
